export default "__VITE_ASSET__df8a1961__"